// LocalBusiness Structured Data for SEO
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://hudsonknox.co.uk/#organization",
  "name": "Hudson Knox Outdoor Living",
  "image": "https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/z8odfgv9_image003.png",
  "url": "https://hudsonknox.co.uk",
  "telephone": "+447846923387",
  "email": "admin@hudsonknox.co.uk",
  "priceRange": "£5,000 - £25,000",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "GB",
    "addressRegion": "South East England"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "51.5074",
    "longitude": "-0.1278"
  },
  "areaServed": [
    {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "51.5074",
        "longitude": "-0.1278"
      },
      "geoRadius": "100000"
    },
    {
      "@type": "Place",
      "name": "London"
    },
    {
      "@type": "Place",
      "name": "Kent"
    },
    {
      "@type": "Place",
      "name": "South East England"
    }
  ],
  "description": "Premium pergola and outdoor structure installation company serving South East England. Authorised Deponti stockist specialising in luxury motorised louvered pergolas, glass verandas, and outdoor living solutions.",
  "paymentAccepted": "Cash, Credit Card, Bank Transfer",
  "openingHours": "Mo-Sa 08:00-18:00",
  "sameAs": [
    "https://hudsonknox.co.uk"
  ]
};

// Service Structured Data
export const getServiceSchema = (serviceName, serviceDescription, serviceUrl) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": serviceName,
  "provider": {
    "@id": "https://hudsonknox.co.uk/#organization"
  },
  "areaServed": {
    "@type": "Place",
    "name": "South East England"
  },
  "description": serviceDescription,
  "url": serviceUrl,
  "audience": {
    "@type": "Audience",
    "audienceType": "Homeowners"
  }
});

// BreadcrumbList Structured Data
export const getBreadcrumbSchema = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": crumb.name,
    "item": `https://hudsonknox.co.uk${crumb.path}`
  }))
});

// FAQPage Structured Data
export const getFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

// Product/Service Offer Schema
export const getOfferSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Offer",
  "name": "Free Pergola Quote",
  "description": "Get a free, no-obligation quote for your luxury pergola installation",
  "url": "https://hudsonknox.co.uk/contact",
  "price": "0",
  "priceCurrency": "GBP",
  "availability": "https://schema.org/InStock",
  "seller": {
    "@id": "https://hudsonknox.co.uk/#organization"
  }
});
